import { FgtsLoanSimulator } from '@/components/FgtsLoanSimulator'
import { withContainer } from '@/hocs/withContainer'

import { BlockContainer } from './styles'

const FgtsLoanSimulatorBlock = ({ url }: { url: string }) => (
  <BlockContainer>
    <FgtsLoanSimulator url={url} />
  </BlockContainer>
)

export default withContainer(FgtsLoanSimulatorBlock, {
  className: 'eu-sp-m',
  spaceIn: 's',
  spaceOut: 'm',
})
